export default __webpack_public_path__ + "static/media/qwikscan.e2ac9cfd.png";